import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import AnalyticsWrapper from "./components/AnalyticsWrapper";
import Header from "./components/Header";
import NotFound from "pages/NotFound";
import Login from './pages/login';
import Register from './pages/register';
import Dashboard from './pages/dashboard';
import BrandManagement from './pages/brand-management';
import BrandDetails from './pages/brand-management/components/BrandDetails';
import ContentScheduler from './pages/content-scheduler';
import CommentAutomation from './pages/comment-automation';
import AccountSettings from './pages/account-settings';
import AIResponseReviewCenter from './pages/ai-response-review-center';
import MultiPlatformResponsePublisher from './pages/multi-platform-response-publisher';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AuthProvider>
          <AnalyticsWrapper>
            <ScrollToTop />
            <RouterRoutes>
              {/* Login and Register pages without Header */}
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              
              {/* Core workflow pages with Header */}
              <Route path="/dashboard" element={<><Header /><Dashboard /></>} />
              <Route path="/brand-management" element={<><Header /><BrandManagement /></>} />
              <Route path="/brand-management/:brandId" element={<><Header /><BrandDetails /></>} />
              <Route path="/content-scheduler" element={<><Header /><ContentScheduler /></>} />
              <Route path="/comment-automation" element={<><Header /><CommentAutomation /></>} />
              <Route path="/ai-response-review-center" element={<><Header /><AIResponseReviewCenter /></>} />
              <Route path="/multi-platform-response-publisher" element={<><Header /><MultiPlatformResponsePublisher /></>} />
              <Route path="/account-settings" element={<><Header /><AccountSettings /></>} />
              
              {/* 404 page */}
              <Route path="*" element={<NotFound />} />
            </RouterRoutes>
          </AnalyticsWrapper>
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;